import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faClock, faShieldAlt, faCogs } from '@fortawesome/free-solid-svg-icons';

const Benefits = () => {
  return (
    <section id="benefits">
      <h2>Benefits of Choosing Our Payroll Service</h2>
      <div className="benefit-container">
        <div className="benefit-item">
          <div className="circle red">
            <FontAwesomeIcon icon={faGlobe} className="benefit-icon" />
          </div>
          <h3 className="benefit-title">Global Expertise</h3>
          <p className="benefit-description">Deep knowledge of local regulations across regions.</p>
        </div>
        <div className="benefit-item">
          <div className="circle yellow">
            <FontAwesomeIcon icon={faClock} className="benefit-icon" />
          </div>
          <h3 className="benefit-title">Time and Cost Efficiency</h3>
          <p className="benefit-description">Automated processes reduce manual errors and save costs.</p>
        </div>
        <div className="benefit-item center">
          <div className="circle purple">
            <FontAwesomeIcon icon={faShieldAlt} className="benefit-icon" />
          </div>
          <h3 className="benefit-title">Scalability</h3>
          <p className="benefit-description">Flexible solutions for companies expanding into new markets.</p>
        </div>
        <div className="benefit-item">
          <div className="circle orange">
            <FontAwesomeIcon icon={faCogs} className="benefit-icon" />
          </div>
          <h3 className="benefit-title">Data Security</h3>
          <p className="benefit-description">Compliant with global data protection laws like GDPR.</p>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
